
import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <div className="footer">
  
    <div className="footer-body">
     <div className="logo logo1">Eraf</div>
      <button>Contact</button>
    </div>
    
    </div>
  )
}

export default Footer;